import {
  CreateDocumentBodyDocument,
  CreateDocumentBodyDocumentCategoryEnum,
  Document
} from "@syadem/kairos-citizen-js";
import { Service } from "../service";
import { Apis } from "../../network/apis";
import { ActionResult } from "../../actionResult";

interface Payload {
  document: {
    name: string;
    category: CreateDocumentBodyDocumentCategoryEnum;
    date?: Date;
  };
  healthRecordId: string;
  attachments: File[];
  onProgressUpdate?: (fileIndex: number, progress: number) => void;
}

export class CreateDocumentAndAttachFilesService implements Service<Payload, Document> {
  constructor(
    private readonly apis: Apis
  ) { }

  async call({
    document,
    healthRecordId,
    attachments,
    onProgressUpdate,
  }: Payload): Promise<ActionResult<Document>> {
    // Create the document first
    let apiDocument = await this.apis.documentApi.createDocument(healthRecordId, {
      document: document as CreateDocumentBodyDocument,
    });

    // Upload each file individually
    if (attachments && attachments.length > 0) {
      for (let i = 0; i < attachments.length; i++) {
        const file = attachments[i];
        apiDocument = await this.apis.documentFileApi.attachFiles(
          healthRecordId,
          apiDocument.id,
          [file],
          (progress) => onProgressUpdate?.(i, progress),
        );
      }
    }

    return {
      type: "success",
      value: apiDocument,
    };
  }
}
